import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import { menus } from "./menus";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { SidebarContext } from "./SidebarContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchMe } from "../../slice/meSlice";
import { logoutUser } from "../../slice/authSlice";
import { Skeleton } from "primereact/skeleton";
import { ModalContext } from "../context/ModalContext";
const API_URL = process.env.REACT_APP_ENDPOINT;
const Navbar = () => {
  const { openEditModal } = useContext(ModalContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menuIsOpen, setIsMenuIsOpen] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const { me, isLoading } = useSelector((state) => state.me);
  const { isOpen } = useContext(SidebarContext);
  const { toggleSidebar } = useContext(SidebarContext);

  const location = useLocation();

  const currentMenu = menus.find(menu =>
    menu.body.some(path => location.pathname === path)
  );

  const currentLabel = currentMenu ? currentMenu.label : "";

  // ====================== NOTIF STATE ======================
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isNotifLoading, setIsNotifLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);


  // Simpen page di state, bukan hardcode
  const [isInitialLoad, setIsInitialLoad] = useState(true); // supaya load pertama beda perilaku

  // ====================== FETCH NOTIFIKASI (5 PER LOAD) ======================
  const playAudio = () => {
  try {
    const audio = new Audio(`${process.env.PUBLIC_URL}/assets/sound/notif.mp3`);
    audio.volume = 1.0;
    audio.play()
      .then(() => console.log("🔊 Notif sound played"))
      .catch((err) => console.warn("Autoplay diblokir:", err));
  } catch (e) {
    console.error("Gagal mainin suara:", e);
  }
};

  // 💡 Toast global buat popup di kanan atas
  const showToast = (title, status = "info") => {
    let iconHtml = "";
    let bgColor = "";
    let textColor = "#fff";

    switch (status.toLowerCase()) {
      case "reject":
      case "error":
        iconHtml = '<i class="bi bi-x-circle-fill"></i>';
        bgColor = "#dc3545"; // merah
        break;
      case "approved":
      case "success":
        iconHtml = '<i class="bi bi-check-circle-fill"></i>';
        bgColor = "#198754"; // hijau
        break;
      default:
        iconHtml = '<i class="bi bi-info-circle-fill"></i>';
        bgColor = "#0d6efd"; // biru
        break;
    }

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      background: bgColor,
      color: textColor,
      customClass: {
        popup: "rounded-4 shadow-lg text-start px-3 py-2",
        title: "fw-semibold fs-6 d-flex align-items-center gap-2",
      },
      didOpen: (toast) => {
        toast.querySelector(".swal2-title").innerHTML =
          `${iconHtml} <span>${title}</span>`;
      },
    });

    Toast.fire({ title });
  };

   const fetchNotifications = async (pageNumber = 1, silent = false) => {
      try {
        if (!silent) setIsNotifLoading(true);

        const response = await axios.get(
          `${API_URL}/notifikasi?page=${pageNumber}&limit=10&kodecabang=${localStorage.getItem("kodecabang")}`
        );

        if (response.data.success) {
          const newData = response.data.data || [];

          // kalau fetch pertama kali
          if (isInitialLoad) {
            setNotifications(newData);
            setIsInitialLoad(false);
            return;
          }

          if (pageNumber === 1) {
            // cek notif baru (bandingin id)
            const oldIds = new Set(notifications.map((n) => n.id));
            const freshNotif = newData.filter((n) => !oldIds.has(n.id));

            // if (freshNotif.length > 0) {
            //   playAudio(); // 🔊 lebih aman & terkontrol
            //   setNotifications((prev) => [...freshNotif, ...prev]);
            // }

            if (freshNotif.length > 0) {
              playAudio(); // 🔊 bunyi notif baru

              // ambil notif terbaru (biasanya paling atas)
              const latest = freshNotif[0];

              // tampilkan popup toast 🔔
              showToast(
                latest.error_stat
                  ? `Warranty ${latest.id} ${latest.error_status}`
                  : `Nomor WO ${latest.id} telah di ${latest.status}.`,
                latest.status
              );

              // tambahkan ke list notif
              setNotifications((prev) => [...freshNotif, ...prev]);
            }
          } else {
            // pagination — load lama di bawah
            setNotifications((prev) => {
              const existingIds = new Set(prev.map((n) => n.id));
              const uniqueNew = newData.filter((n) => !existingIds.has(n.id));
              return [...prev, ...uniqueNew];
            });
          }

          setHasMore(newData.length >= 10);
        } else {
          setHasMore(false);
        }
      } catch (error) {
        console.error("Gagal fetch notifikasi:", error);
      } finally {
        if (!silent) setIsNotifLoading(false);
      }
    };



  // ====================== FETCH USER + FIRST LOAD ======================
  // useEffect(() => {
  //   dispatch(fetchMe()).unwrap();
  //   fetchNotifications(1);

  //   const interval = setInterval(() => {
  //     setPage(1);
  //     fetchNotifications(1);
  //   }, 30000);
  //   return () => clearInterval(interval);
  // }, [dispatch]);

  useEffect(() => {
  const enableSound = () => {
    const audio = new Audio(`${process.env.PUBLIC_URL}/assets/sound/notif.mp3`);
    audio.play().then(() => {
      audio.pause();
      audio.currentTime = 0;
      console.log("🔔 Notif sound ready");
    }).catch(() => {});
    document.removeEventListener("click", enableSound);
  };

  document.addEventListener("click", enableSound);
  return () => document.removeEventListener("click", enableSound);
}, []);

useEffect(() => {
  const interval = setInterval(() => fetchNotifications(1, true), 30000);
  return () => clearInterval(interval);
}, [notifications]);

  // ====================== INFINITE SCROLL DETECTOR ======================
  useEffect(() => {
    const handleScroll = (e) => {
      const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 10;

      if (bottom && !isNotifLoading && hasMore) {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchNotifications(nextPage);
      }
    };

    const drawer = document.querySelector(".notif-drawer");
    if (drawer) drawer.addEventListener("scroll", handleScroll);

    return () => {
      if (drawer) drawer.removeEventListener("scroll", handleScroll);
    };
  }, [page, isNotifLoading, hasMore]);

  // ====================== LOGOUT ======================
  const logoutHandle = () => {
    setIsButtonDisabled(true);
    dispatch(logoutUser())
      .unwrap()
      .then((response) => {
        setIsButtonDisabled(false);
        navigate("/login");
        Swal.fire("Success", response.message, "success");
      })
      .catch((error) => {
        setIsButtonDisabled(false);
        Swal.fire("Error", error, "error");
        navigate("/login");
      });
  };

  // ====================== KLIK NOTIF (OPEN DETAIL) ======================
  const handleNotifClick = (notif) => {
    if (typeof openEditModal === "function") {
      openEditModal({
        rep_order_no: notif.id,
        status_claim: notif.status,
        error_stat: notif.error_stat,
      });
      setNotifOpen(false);
    } else {
      console.warn("openEditModal belum dikirim ke Navbar");
    }
  };

  

  // ====================== RETURN ======================
  return (
    <>
      <nav className="navbar navbar-expand-lg text-white">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          {isOpen ? (
            <div></div>
          ) : (
            <>
            <i
              className="bi bi-list fs-4 me-3 d-md-none"
              style={{ cursor: "pointer" }}
              onClick={toggleSidebar}
            />
            <div style={{ textSize: "14px" }} className="fw-semibold d-flex align-items-center mb-0">{currentLabel || "Dashboard"}</div>
            </>
          )}

          {Object.keys(me).length <= 0 ? (
            <div className="d-flex gap-1">
              <div
                className="card rounded-circle"
                style={{
                  backgroundColor: "#444e59",
                  border: "none",
                  height: "35px",
                  width: "35px",
                  animation: "blink 1s infinite",
                }}
              ></div>
              <div
                className="card rounded-circle"
                style={{
                  backgroundColor: "#444e59",
                  border: "none",
                  height: "35px",
                  width: "35px",
                  animation: "blink 1s infinite",
                }}
              ></div>
            </div>
          ) : (
            <div className="d-flex gap-2 align-items-center text-white">
              <span>
                <strong>{localStorage.getItem("namacabang")}</strong>
              </span>

              <div className="position-relative">
                <button
                  className="btn text-white position-relative"
                  onClick={() => {
                    setNotifOpen(!notifOpen);
                    if (!notifOpen) {
                      setPage(1);
                      fetchNotifications(1);
                    }
                  }}
                >
                  <i className="bi bi-bell" style={{ fontSize: "1.4rem", position: "relative" }}></i>
                  {notifications.length > 0 && (
                    <span
                      className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
                      style={{
                        width: "12px",
                        height: "12px",
                        padding: 0,
                      }}
                    ></span>
                  )}
                </button>
              </div>

              <button
                className="btn rounded-circle text-white fw-semibold"
                style={{ cursor: "pointer" }}
                onClick={() => setIsMenuIsOpen(true)}
              >
                <i className="bi bi-gear"></i>
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* ====================== DRAWER NOTIF ====================== */}
      <div
        className={`notif-drawer shadow ${notifOpen ? "open" : ""}`}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          width: "340px",
          backgroundColor: "white",
          zIndex: 1050,
          transition: "transform 0.3s ease",
          transform: notifOpen ? "translateX(0)" : "translateX(100%)",
          overflowY: "auto",
          borderLeft: "1px solid #dee2e6",
        }}
      >
        <div className="p-3 border-bottom sticky-top bg-white d-flex justify-content-between align-items-center">
          <h6 className="m-0 fw-semibold">Notifikasi</h6>
          <button className="btn btn-sm" onClick={() => setNotifOpen(false)}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {notifications.length === 0 && !isNotifLoading ? (
          <div className="text-center text-secondary p-3">
            Tidak ada notifikasi
          </div>
        ) : (
          <>
            {notifications.map((n) => (
              <div
                key={n.id}
                className="d-flex align-items-start gap-2 p-2 border-bottom"
                style={{
                  backgroundColor:
                    n.status === "Reject" ? "#fff5f5" : "#f6fff7",
                  cursor: "pointer",
                }}
                onClick={() => handleNotifClick(n)}
              >
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor:
                      n.status === "Reject" ? "#f8d7da" : "#d1e7dd",
                    width: "35px",
                    height: "35px",
                    flexShrink: 0,
                  }}
                >
                  <i
                    className={`bi ${
                      n.status === "Reject"
                        ? "bi-x-octagon"
                        : "bi-check-circle"
                    } ${
                      n.status === "Reject" ? "text-danger" : "text-success"
                    } fs-6`}
                  ></i>
                </div>

                <div>
                  <div className="fw-semibold">
                    Nomor WO <strong>{n.id}</strong> telah di{" "}
                    <span
                      className={
                        n.status === "Reject" ? "text-danger" : "text-success"
                      }
                    >
                      {n.status}
                    </span>
                  </div>

                  {n.status === "Reject" && n.error_stat && (
                    <div
                      style={{
                        backgroundColor: "#ffe6e6",
                        border: "1px solid #f5c2c7",
                        color: "#dc3545",
                        borderRadius: "5px",
                        padding: "6px 10px",
                        marginTop: "5px",
                        fontSize: "0.85rem",
                      }}
                    >
                      {n.error_stat}
                    </div>
                  )}

                  <div
                    className="text-secondary"
                    style={{ fontSize: "0.8rem", marginTop: "3px" }}
                  >
                    {n.created_at}
                  </div>
                </div>
              </div>
            ))}

            {/* Spinner di bawah saat load tambahan */}
            {isNotifLoading && hasMore && (
              <div className="text-center text-secondary py-2">
                <div className="spinner-border spinner-border-sm me-2"></div>
                Memuat notifikasi berikutnya...
              </div>
            )}
          </>
        )}
        <div className="p-3 border-top bg-white sticky-bottom">
          <button
            className="btn btn-outline-dark w-100"
            onClick={() => setNotifOpen(false)}
          >
            Tutup
          </button>
        </div>
      </div>

      {/* ====================== PROFILE MENU ====================== */}
        <div
          className={`menu-profile rounded-bottom-4 shadow-sm ${menuIsOpen ? "open" : ""}`}
          style={{
            position: "fixed",
            top: 0,
            right: "10px",
            width: "250px",
            zIndex: 1002,
            backgroundColor: "white",
          }}
          onMouseLeave={() => setIsMenuIsOpen(false)}
        >
          {/* Tombol close */}
          <div className="row justify-content-end my-2">
            <div className="col-4 d-flex align-items-end justify-content-end">
              <button
                className="btn fw-semibold"
                style={{ cursor: "pointer" }}
                onClick={() => setIsMenuIsOpen(false)}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
          </div>

          {/* Icon Profile */}
          <div className="d-flex justify-content-center">
            {isLoading ? (
              <Skeleton shape="circle" size="5rem" />
            ) : (
              <i className="bi bi-person-circle rounded-circle" style={{ fontSize: "70px" }}></i>
            )}
          </div>

          {/* Nama */}
          <div className="d-flex justify-content-center">
            {isLoading ? (
              <Skeleton width="100px" borderRadius="10px" className="my-1" />
            ) : (
              <span className="fw-semibold">{me?.name}</span>
            )}
          </div>

          {/* Email */}
          <div className="d-flex justify-content-center">
            {isLoading ? (
              <Skeleton width="150px" borderRadius="10px" className="my-1" />
            ) : (
              <span className="fs-7 text-secondary">{me?.email}</span>
            )}
          </div>

          {/* Tombol Logout */}
          <div className="row align-items-end p-3">
            <div className="col-12">
              {isLoading ? (
                <Skeleton width="100%" height="2.5rem" borderRadius="10px" />
              ) : (
                <button
                  type="submit"
                  className="btn btn-outline-dark w-100"
                  onClick={logoutHandle}
                  disabled={isButtonDisabled}
                >
                  {isButtonDisabled ? "Loading..." : "Logout"}
                </button>
              )}
            </div>
          </div>
        </div>
    </>
  );
};

export default Navbar;
